var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrandeIconeInfos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12 Copy@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accueil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-15",
    transform: "translate(-392.000000, -772.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(361.000000, 743.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy",
    transform: "translate(31.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#01205C",
    cx: 9.5,
    cy: 9.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(7.000000, 3.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information",
    transform: "translate(0.000000, 0.195352)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 2.72727273,
    cy: 1.7244898,
    rx: 1.81818182,
    ry: 1.7244898
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50400794,10.6895674 L4.50400794,4.79859265 C4.50400794,4.53127226 4.27785714,4.31449516 3.99888889,4.31449516 C3.9825,4.31449516 0.512460317,4.31122449 0.496031746,4.31122449 C0.222103175,4.31122449 0,4.52408439 0,4.78661287 C0,5.04914135 0.222103175,5.26200124 0.496031746,5.26200124 L1.13095238,5.26200124 L1.13095238,10.6895294 C0.85702381,10.6895294 0.634920635,10.9023893 0.634920635,11.1649177 C0.634920635,11.4274462 0.85702381,11.6403061 1.13095238,11.6403061 L4.50396825,11.6403061 C4.77789683,11.6403061 5,11.4274462 5,11.1649177 C5.00003968,10.9023893 4.77797619,10.6895674 4.50400794,10.6895674 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandeIconeInfos);
export default __webpack_public_path__ + "static/media/grande-icone-infos.6d3ae90b4ae8fa38bf9d7b4fb0e575fb.svg";
export { ForwardRef as ReactComponent };